var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"charttitle"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('fin-data-loader',{ref:"loader",attrs:{"resolver":_vm.loadData,"data-adapter":_vm.adapt,"small-loader":_vm.small,"overlay":""},scopedSlots:_vm._u([{key:"content",fn:function(ref){
var data = ref.data;
return [_c('fin-chart2',{attrs:{"options":data}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }